export const getBodyPlainText = (htmlString = "", maxLength) => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const body = doc.body;

    const text =
      body.textContent && body.textContent.trim() !== ""
        ? body.textContent
        : doc.documentElement.textContent;

    if (maxLength && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  } catch (e) {
    const div = document.createElement("div");
    div.innerHTML = htmlString;
    const text = div.textContent || div.innerText || "";
    if (maxLength && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }
};
